import { RightOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

export const MenuButton = ({
  redirection,
  icon,
  message,
}: {
  redirection: string;
  icon: ReactNode;
  message: string;
}) => {
  return (
    <Link
      to={redirection}
      className="flex w-full justify-between rounded-[20px] bg-blue-50! p-4"
    >
      <div className="flex items-center">
        <div className="mr-5 flex h-14 w-14 items-center justify-center rounded-lg bg-blue-100">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
            {icon}
          </div>
        </div>

        <span className="text-lg text-black">{message}</span>
      </div>

      <RightOutlined className="pr-2 text-xl text-black" />
    </Link>
  );
};
